import Vue from 'vue'

import { Dialog, VDialog, DialogHost } from './Dialog';
import VideoPlayer from './VideoPlayer.vue';

export default function load() {
	Vue.component('app-dialog', Dialog);
	Vue.component('dialog-host', DialogHost);
	Vue.component('video-player', VideoPlayer);
	Vue.directive('dialog', VDialog);
}
